import { Layout } from 'antd'
import Loading from 'components/Loading'
import React, { ReactNode, Suspense } from 'react'

import './EmptyOnboardingLayout.scss'

const { Content } = Layout

interface IProps {
  children: ReactNode
}

const EmptyOnboardingLayout = ({ children }: IProps) => {
  return (
    <Layout className="onboarding-layout">
      <Suspense fallback={<Loading />}>
        <Content>{children}</Content>
      </Suspense>
    </Layout>
  )
}

export default EmptyOnboardingLayout
